import { Middleware, } from './core';
import { Configuration } from '@spotify-internal/remote-config-properties';
import { getLogger, } from '@spotify-internal/remote-config-common';
const logger = getLogger('core');
export function createResolver(factory) {
    return recreateResolver(factory);
}
function recreateResolver(factory) {
    return class {
        constructor(options) {
            this.onDestroyListeners = new Set();
            this.logger = getLogger('core');
            const providedOptions = {
                onDestroy: listener => {
                    this.onDestroyListeners.add(listener);
                },
            };
            this.delegate = factory(Object.assign(Object.assign({}, options), providedOptions));
        }
        resolve(context) {
            return Promise.resolve()
                .then(() => this.delegate(context))
                .then(builder => builder.build())
                .catch(error => {
                this.logger.warn('Uncaught error in resolve chain:', error);
                return Configuration.empty();
            });
        }
        destroy() {
            this.delegate = () => {
                throw new Error('Resolver instance has been destroyed');
            };
            for (const listener of this.onDestroyListeners) {
                try {
                    listener();
                }
                catch (e) {
                    logger.warn('uncaught error in onDestroy listener', e);
                }
            }
            this.onDestroyListeners.clear();
        }
        static addMiddleware(middleware) {
            return recreateResolver(Middleware.apply(middleware, factory));
        }
        static withIdentifier(_identifier) {
            return this;
        }
    };
}
//# sourceMappingURL=resolver.js.map